import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultCheckboxs } from "../../../../Constant";
import { DEFAULT_CHECKBOX, DEFAULT_CHECKBOX_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { DefaultChecks } from "./DefaultChecks";
import { Indeterminates } from "./Indeterminates";
import { H6 } from "../../../../AbstractElements";

const DefaultCheckbox = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={DefaultCheckboxs} span={DEFAULT_CHECKBOX} />
        <CardBody>
          <Row className="g-3">
            <DefaultChecks />
            {DEFAULT_CHECKBOX_LIST.map(({ title, span, className }, index) => (
              <Col sm="6" xl="4" key={index}>
                <div className="card-wrapper border rounded-3 checkbox-checked">
                  <H6 className="sub-title">{title}</H6>
                  {span.map(({ id, label, defaultChecked, disabled }, index) => (
                    <div className={`form-check ${className}`} key={index}>
                      <Input id={id} type="checkbox" defaultChecked={defaultChecked} disabled={disabled} />
                      <Label htmlFor={id} check>{label}</Label>
                    </div>
                  ))}
                </div>
              </Col>
            ))}
            <Indeterminates />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultCheckbox;
